// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Loading_wrapper__1nM4_","loading":"Loading_loading__M8Nus"};